// // current code
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import InsightsIcon from "@mui/icons-material/Insights";
// import PolylineIcon from "@mui/icons-material/Polyline";
// import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
// import WorkspacesIcon from "@mui/icons-material/Workspaces";
// import { List, ListItem } from "@mui/material";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import React from "react";
// import { NavLink } from "react-router-dom";
// import logo from "../../assets/images/analyticsWhite.svg";

// const NormalSidebar = ({
//   handleMenuClick,
//   pathName,
//   anchorEl,
//   handleClose,
//   setDashboardOpen,
//   setForecastOpen,
//   ToggleForecast,
//   ToggleDash,
//   setOnWorkspace,
//   CollapsedListItemIcon,
//   handleMouseLeave,
// }) => {
//   return (
//     <div className={`${pathName === "/workspace" ? "close" : ""}`}>
//       <div className="flex justify-center mt-3 ">
//         <img src={logo} alt="" width="25" height="25" />
//       </div>
//       <List sx={{ marginTop: 4 }}>
//         <NavLink
//           to="/workspace"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//             setOnWorkspace(true);
//           }}
//           title="Workspace"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <WorkspacesIcon
//                 color={pathName === "/workspace" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>
//         <NavLink to="#" title="Dashboards" onClick={() => ToggleDash()}>
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <SpaceDashboardIcon
//                 color={pathName === "/home" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>
//         <NavLink
//           to="/widget-generator"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//           }}
//           title="Widget Generator"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <PolylineIcon
//                 color={pathName === "/widget-generator" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>

//         {/* <NavLink
//           to="/forecasting/forecasting"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//           }}
//           title="Forecasting"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <InsightsIcon
//                 color={pathName === "/forecasting/forecasting" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink> */}

//         {/* <NavLink to="#" onClick={() => ToggleForecast()} title="Forecasting">
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <InsightsIcon
//                 color={pathName === "/Forecasting" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink> */}

//         <div
//           style={{
//             position: "fixed",
//             bottom: 0,
//           }}
//           className="flex justify-center items-center   mx-2"
//         >
//           <IconButton
//             className="dropdown-trigger"
//             data-target="account-dropdown"
//             onClick={handleMenuClick}
//           >
//             <AccountCircleIcon style={{ color: "grey", fontSize: "28px" }} />
//           </IconButton>
//           <Menu
//             anchorEl={anchorEl}
//             keepMounted
//             open={Boolean(anchorEl)}
//             PaperProps={{
//               style: {
//                 left: "50%",
//                 transform: "translateX(25%) translateY(1330%)",
//               },
//             }}
//             onClick={handleMenuClick}
//             onClose={handleMenuClick}
//           >
//             <MenuItem onMouseLeave={handleMouseLeave} onClick={handleClose}>
//               Logout
//             </MenuItem>
//           </Menu>
//         </div>
//       </List>
//       {/* <style>{styles}</style> */}
//     </div>
//   );
// };

// export default NormalSidebar;
























//current code for design fix in logout 
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InsightsIcon from "@mui/icons-material/Insights";
import PolylineIcon from "@mui/icons-material/Polyline";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import { List, ListItem, Popover, Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/analyticsWhite.svg";

const NormalSidebar = ({
  handleMenuClick,
  pathName,
  anchorEl,
  handleClose,
  setDashboardOpen,
  setForecastOpen,
  ToggleForecast,
  ToggleDash,
  CollapsedListItemIcon,
  handleMouseLeave,
}) => {
  // Get the first letter of the username for the avatar
  const username = localStorage.getItem("user") || "User";
  const userInitial = username.charAt(0).toUpperCase();
  
  // State for account menu
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
  const isAccountMenuOpen = Boolean(accountMenuAnchorEl);
  
  // Handle account icon click
  const handleAccountClick = (event) => {
    setAccountMenuAnchorEl(event.currentTarget);
  };
  
  // Handle closing the account menu
  const handleAccountMenuClose = () => {
    setAccountMenuAnchorEl(null);
  };
  
  // Handle profile click
  const handleProfileClick = () => {
    // Add your profile navigation logic here
    handleAccountMenuClose();
  };
  
  // Handle settings click
  const handleSettingsClick = () => {
    // Add your settings navigation logic here
    handleAccountMenuClose();
  };
  
  // Handle logout click
  const handleLogoutClick = () => {
    handleClose(); // Use the existing logout function
    handleAccountMenuClose();
  };

  return (
    <div className={`${pathName === "/workspace" ? "close" : ""}`}>
      <div className="flex justify-center mt-3 ">
        <img src={logo} alt="" width="25" height="25" />
      </div>
      <List sx={{ marginTop: 4 }}>
        <NavLink
          to="/workspace"
          onClick={() => {
            setDashboardOpen(false);
            setForecastOpen(false);
          }}
          title="Workspace"
        >
          <ListItem className="d-flex justify-content-center mb-2" button>
            <CollapsedListItemIcon>
              <WorkspacesIcon
                color={pathName === "/workspace" ? "primary" : ""}
              />
            </CollapsedListItemIcon>
          </ListItem>
        </NavLink>
        <NavLink to="#" title="Dashboards" onClick={() => ToggleDash()}>
          <ListItem className="d-flex justify-content-center mb-2" button>
            <CollapsedListItemIcon>
              <SpaceDashboardIcon
                color={pathName === "/home" ? "primary" : ""}
              />
            </CollapsedListItemIcon>
          </ListItem>
        </NavLink>
        <NavLink
          to="/widget-generator"
          onClick={() => {
            setDashboardOpen(false);
            setForecastOpen(false);
          }}
          title="Widget Generator"
        >
          <ListItem className="d-flex justify-content-center mb-2" button>
            <CollapsedListItemIcon>
              <PolylineIcon
                color={pathName === "/widget-generator" ? "primary" : ""}
              />
            </CollapsedListItemIcon>
          </ListItem>
        </NavLink>

        <div
          style={{
            position: "fixed",
            bottom: "10px",
            paddingBottom: "15px",
          }}
          className="flex justify-center items-center mx-2"
        >
          <Tooltip title="Account" placement="left">
            <Avatar
              onClick={handleAccountClick}
              onMouseEnter={handleAccountClick}
              sx={{
                bgcolor: "#305697",
                width: 32,
                height: 32,
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AccountCircleIcon fontSize="small" />
            </Avatar>
          </Tooltip>
          
          <Popover
            open={isAccountMenuOpen}
            anchorEl={accountMenuAnchorEl}
            onClose={handleAccountMenuClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            PaperProps={{
              onMouseLeave: handleAccountMenuClose
            }}
          >
            <Box sx={{ display: 'flex', p: 1 }}>
              {/* <Tooltip title="Profile">
                <Avatar 
                  onClick={handleProfileClick}
                  sx={{ 
                    bgcolor: '#305697', 
                    width: 32, 
                    height: 32,
                    fontSize: '14px',
                    cursor: 'pointer',
                    mx: 0.5
                  }}
                >
                  <PersonIcon fontSize="small" />
                </Avatar>
              </Tooltip> */}
              
              {/* <Tooltip title="Settings">
                <Avatar 
                  onClick={handleSettingsClick}
                  sx={{ 
                    bgcolor: '#305697', 
                    width: 32, 
                    height: 32,
                    fontSize: '14px',
                    cursor: 'pointer',
                    mx: 0.5
                  }}
                >
                  <SettingsIcon fontSize="small" />
                </Avatar>
              </Tooltip> */}
              
              <Tooltip title="Logout">
                <Avatar 
                  onClick={handleLogoutClick}
                  sx={{ 
                    bgcolor: '#305697', 
                    width: 32, 
                    height: 32,
                    fontSize: '14px',
                    cursor: 'pointer',
                    mx: 0.5
                  }}
                >
                  <LogoutIcon fontSize="small" />
                </Avatar>
              </Tooltip>
            </Box>
          </Popover>
        </div>
      </List>
    </div>
  );
};

export default NormalSidebar;